<template>
  <nuxt-link
    class="w-(--width) active:scale-97 group relative block aspect-[0.7] overflow-hidden rounded-lg transition"
    :show-description-short="showDescriptionShort"
    :style="{
      '--width': carouselContext ? `${carouselContext.itemWidth}px` : undefined,
    }"
    :to="{ name: 'trainers-slug', params: { slug: teacher.slug! } }"
  >
    <teacher-card-profile class="h-full" :teacher="teacher" />

    <div
      class="pointer-coarse:hidden background-blend-color absolute inset-0 flex flex-col p-4 opacity-0 backdrop-blur-lg transition transition-all duration-500 group-hover:opacity-100"
      :style="{ backgroundColor: overlayColor }"
    >
      <p
        class="grid flex-auto translate-y-3 place-content-center text-balance text-xl font-bold text-white opacity-0 transition duration-300 group-hover:translate-y-0 group-hover:opacity-100"
      >
        {{ teacher.description_short }}
      </p>
      <app-button
        block
        class="translate-y-3 opacity-0 transition duration-300 group-hover:translate-y-0 group-hover:opacity-100"
        color="light"
        tag="span"
      >
        Voir le profil
      </app-button>
    </div>
  </nuxt-link>
</template>

<script lang="ts" setup>
import { type TeacherCardProps } from "~/business-areas/teacher/teacher.model";
import {
  type CarouselProvidedState,
  CarouselProvideKey,
} from "~/shared/carousel/carousel.model";

const properties = withDefaults(
  defineProps<
    {
      teacher: Pick<
        DatabaseTable<"teachers">,
        | "id"
        | "full_name"
        | "first_name"
        | "avatar_url"
        | "slug"
        | "pinned"
        | "description_short"
        | "job"
        | "cover_url"
      > & {
        tags: DatabaseTable<"tags">[];
        companies: DatabaseTable<"companies">[];
      };
    } & TeacherCardProps
  >(),
  {
    contentVisibility: "auto",
  },
);

const carouselContext = inject<CarouselProvidedState | null>(
  CarouselProvideKey,
  null,
);

const overlayColor = computed(() => {
  return hexToHSLA(
    properties.tag?.color ?? properties.teacher.tags[0]?.color ?? "#50228F",
    {
      luminance: 40,
      saturation: 50,
      alpha: 30,
    },
  );
});
</script>
